/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import FlatList from 'flatlist-react';
import { Row, Col, Nav } from 'react-bootstrap';
// import { AppCard, IAppCardList } from "@vlinder-web/app-card-widget-react";
import {
  AppCard,
  IAppCardList,
} from '../../../../widgets/app-card-widget-react';

import {
  StateOSD,
  IStateOSDProps,
} from '@vlinder-web/state-osd-v2-widget-react';

import { useTheme } from '../../../../providers/theme';

import * as S from './styles';

export interface IAppCardListCompProps {
  appCardList?: IAppCardList[];
  appCardGridRow?: {
    xs: 1 | 2 | 3 | 4;
    md: 1 | 2 | 3 | 4;
    lg: 1 | 2 | 3 | 4;
  };
  onCardClick?(id: string): void;
  totalCount: number;
  totalPages: number;
  activePage: number;
  onPageChange?(page: number): void;
  emptyListProps?: IStateOSDProps;
}

export const AppCardListComp = ({
  appCardList,
  gridRow,
  onCardClick,
  emptyListProps,
}: IAppCardListCompProps) => {
  const theme = useTheme();
  const _renderItem = (appCard: any, index: number) => {
    return (
      <Col
        key={`app-card-col-${index}`}
        xs={gridRow?.xs ? 12 / gridRow?.xs : 12}
        md={gridRow?.md ? 12 / gridRow?.md : 6}
        lg={gridRow?.lg ? 12 / gridRow?.lg : 4}
        style={S.CardContainerStyle}
        onClick={() => onCardClick && onCardClick(appCard)}
      >
        <AppCard
          {...(appCard || { id: index })}
          hoverColor={theme?.colors?.secondary}
        />
      </Col>
    );
  };
  return (
    <>
      <Row>
        <FlatList
          list={appCardList}
          renderItem={_renderItem}
          renderWhenEmpty={() => <StateOSD {...(emptyListProps || {})} />}
        />
      </Row>
    </>
  );
};

AppCardListComp.defaultProps = {
  appCardList: [
    // {
    //   id: "1",
    //   appCardImage: "https://s3.ap-south-1.amazonaws.com/io.vlinder.images/fhp-favicon.png",
    //   appCardTitle: "Flexible Hurricane Protection",
    //   appCardDescription: "Year 2023-24",
    //   appCardList:[
    //     {
    //       value:"B2CGS50000123"
    //     }
    //   ]
    // }
  ],
};
